// action - customization and api request reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const SET_INIT_DATA = '@api/SET_INIT_DATA';
export const FETCH_FILMS = '@filmsSlice/FETCH_FILMS';
export const FETCH_FILM = '@filmSlice/FETCH_FILM';
export const FETCH_PEOPLE = '@peopleSlice/FETCH_PEOPLE';
export const FETCH_PERSON = '@personSlice/FETCH_PERSON';
export const FETCH_PLANETS = '@planetsSlice/FETCH_PLANETS';
export const FETCH_PLANET = '@planetSlice/FETCH_PLANET';
export const FETCH_SPECIES = '@speciesSlice/FETCH_SPECIES';
export const FETCH_SPECIFIC_SPECIES = '@specificSpeciesSlice/FETCH_SPECIFIC_SPECIES';
export const FETCH_STARSHIPS = '@starshipsSlice/FETCH_STARSHIPS';
export const FETCH_STARSHIP = '@starshipSlice/FETCH_STARSHIP';
export const FETCH_VEHICLES = '@vehiclesSlice/FETCH_VEHICLES';
export const FETCH_VEHICLE = '@vehicleSlice/FETCH_VEHICLE';
export const SEARCH_FILMS = '@searchFilmsSlice/SEARCH_FILMS';
export const SEARCH_PEOPLE = '@searchPeopleSlice/SEARCH_PEOPLE';
export const SEARCH_PLANETS = '@searchPlanetsSlice/SEARCH_PLANETS';
export const SEARCH_SPECIES = '@searchSpeciesSlice/SEARCH_SPECIES';
export const SEARCH_STARSHIPS = '@searchStarshipsSlice/SEARCH_STARSHIPS';
export const SEARCH_VEHICLES = '@searchVehiclesSlice/SEARCH_VEHICLES';
export const WOOKIEE_TOGGLE = '@customization/WOOKIEE_TOGGLE';
export const FILMS_COUNT = '@filmsCountSlice/FILMS_COUNT';
export const PEOPLE_COUNT = '@peopleCountSlice/PEOPLE_COUNT';
export const PLANETS_COUNT = '@planetsCountSlice/PLANETS_COUNT';
export const SPECIES_COUNT = '@speciesCountSlice/SPECIES_COUNT';
export const STARSHIPS_COUNT = '@starshipsCountSlice/STARSHIPS_COUNT';
export const VEHICLES_COUNT = '@vehiclesCountSlice/VEHICLES_COUNT';
